import React from "react";

// import { Button } from "react-bootstrap";
  
function NotFound () {

    // const redirect = () => window.location.href = "/";

    return (
        <main role="main" id="view_err404">
            <div className="_med-container">
                <div className="content-error">
                    <h1 className="title">
                        404
                    </h1>
                    <div className="content">
                        <h2 className="subtitle">
                            <span>Oops..</span>
                            Página não encontrada!
                        </h2>
                        <p className="text">
                        O endereço da página mudou ou a página<br/> não existe.
                        </p>
                        {/* <Button 
                            className="back-home"
                            color="primary"
                            autoFocus
                            type="button"
                            onClick={redirect}
                        >
                        Voltar para a home
                        </Button>  */}
                    </div>
                </div>
            </div>
        </main>
    )
}

export default NotFound;